export enum Sample {
  SAMPLE = 'sample',
}

export enum StatusType {
  STARTED = 1,
  AVAILABLE = 2,
  FINISHED = 3,
  NOTAVAILABLE = 4,
  WAITT0START = 5,
}

export const STORE_LINKS = {
  ios: 'https://apps.apple.com/tr/app/tcsofor/id6760003004?l=tr',
  android: 'https://play.google.com/store/apps/details?id=com.tcsofor.tcsofor',
} as const
